import React, { Component } from "react";
import { ProjectService } from "../../Services/ProjectService";
import { JobStatusTransactionService } from "../../Services/JobStatusTransactionService";
import { StoreTransactionService } from "../../Services/StoreTransactionService";
import {toInt} from '../../Utils';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      paddingTop : theme.spacing.unit, 
      paddingLeft: theme.spacing.unit, 
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    formControl: {
        margin: theme.spacing.unit,
        marginTop: theme.spacing.unit * 3,
        minWidth: 200,
        marginLeft: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing.unit * 4,
        },
    },
    card: {
        maxWidth: 600,
        minWidth: 300,
        minHeight: 184,
        margin: 5
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
  });

class ProjectReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        message : '',
        project_phase_rows: [],
        project_items_rows: [],
        project_names: [],
        selected_project_id: '',
        contractor_list: '',
        expanded: {}
      }
    }

    componentWillMount(){
        this.props.setTitle('Project Status');
        this.props.isLoading(true);
        ProjectService.getProjectNames()
        .then((data) => {
            let project_names = data.projects.filter(p => p.id !== '999').map((project) => (
                <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
            ));
            this.setState({project_names: project_names});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchData(){
        this.props.isLoading(true);
        let project_id = this.state.selected_project_id;

        Promise.all([
        JobStatusTransactionService.getJobStatusTransactionsForProject(project_id),
        StoreTransactionService.getStoreTransactionsForProject(project_id)
        ])
        .then(([jobStatusTransactions, storeTransactions]) => {
            this.props.isLoading(false);
            this.setState({
                project_job_status_txns: jobStatusTransactions.transactions,
                project_store_txns: storeTransactions.transactions
            }, () => this.updateProjectProgress());
        })
        .catch((error) => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleExpandClick = (id) => {
        let expanded = this.state.expanded;
        expanded[id] =  !expanded[id];
        this.setState({expanded});
    };

    updateProjectProgress = () => {
        let project = this.state.selected_project;
        let totalCount = toInt(project.qty);
        let contractorNameSet = new Set(this.state.project_job_status_txns.map(j => j.contractor_name));
        let contractorNameSetStoreTxn = new Set(this.state.project_store_txns.map(j => j.contractor_name));
        let project_phase_rows = project.job_actions.map(action => {
            let sum = this.state.project_job_status_txns.filter(jst => jst.job_action_id === action.job_action_id && jst.project_id === project.id).reduce(function(sum, txn, idx) {
                return sum + toInt(txn.qty);
            }, 0);
            let cont_data = [];
            contractorNameSet.forEach(element => {
                cont_data.push({
                    name: element,
                    count: this.state.project_job_status_txns.filter(jst => jst.job_action_id === action.job_action_id && jst.contractor_name === element  && jst.project_id === project.id).reduce(function(sum, txn, idx) {
                    return sum + toInt(txn.qty);
                }, 0)});
            });
            let rows = cont_data.map((p, i) => (
                p.count > 0 && 
                <Grid key={i} item container direction="row" spacing={8}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" component="h5" align="justify">
                            {p.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">{p.count}</Typography>
                    </Grid>
                </Grid>
            ));
            return (
                    <ExpansionPanel key={action.job_action_id}  style={{width: "100%"}}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Grid item container direction="row" spacing={8}>
                                <Grid item xs={6}>
                                    <Typography variant="h5" component="h2" align="justify">
                                        {action.job_action_name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1">{sum} / {totalCount}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <LinearProgress color={sum > totalCount ? 'secondary' : 'primary'} variant="determinate" value={sum / totalCount * 100} style={{height: 20}}/>
                                </Grid>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {rows}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
            );
        });

        let project_items_rows = project.items.map(item => {
            let sum = this.state.project_store_txns.filter(st => st.item_id === item.item_id && st.project_id === project.id).reduce(function(sum, txn, idx) {
                return sum + toInt(txn.qty);
            }, 0);
            let cont_data = [];
            contractorNameSetStoreTxn.forEach(element => {
                cont_data.push({
                    name: element,
                    count: this.state.project_store_txns.filter(st => st.item_id === item.item_id && st.contractor_name === element  && st.project_id === project.id).reduce(function(sum, txn, idx) {
                    return sum + toInt(txn.qty);
                }, 0)});
            });
            let rows = cont_data.map((p, i) => (
                p.count > 0 && 
                <Grid key={i} item container direction="row" spacing={8}>
                    <Grid item xs={8}>
                        <Typography variant="subtitle1" component="h5" align="justify">
                            {p.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="subtitle1">{p.count}</Typography>
                    </Grid>
                </Grid>
            ));
            return (
                    <Card key={item.item_id} className={this.props.classes.card}>
                        <CardHeader
                            title={item.item_name}
                            subheader={`Allowed Qty: ${item.qty}, Used: ${sum}`}
                        />
                        <CardContent>
                            {rows}
                        </CardContent>
                        
                    </Card>
            );
        });
        
        let contractor_list =  '';
        let new_list = new Set([...contractorNameSet, ...contractorNameSetStoreTxn]);
        new_list.forEach((s,i) => {
            i === contractorNameSet.size -1 ? contractor_list += s : contractor_list += s + ', ' 
        });
        this.setState({project_phase_rows: project_phase_rows, project_items_rows: project_items_rows, contractor_list: contractor_list.substring(0, contractor_list.length - 2)});
    }

    handleProjectSelection = (e) => {
        this.setState({selected_project_id: e.target.value}, () => this.fetchProjectInfo());
    }
    
    fetchProjectInfo = () => {
        let project_id = this.state.selected_project_id;
        ProjectService.getProjectInfo(project_id)
        .then((data) => {
            let expanded = this.state.expanded;
            data.items.forEach(element => {
                expanded[element.item_id] = false;
            });
            this.setState({selected_project: data, expanded: expanded}, () => this.fetchData());
        })
    }

    render() {
        let message = this.state.message;
        const { classes } = this.props;
        return (
            <div className="Home">
                <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                    <InputLabel
                        ref={ref => {
                        this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-project-simple"
                    >
                        Select Project
                    </InputLabel>
                    <Select
                        value={this.state.selected_project_id}
                        onChange={this.handleProjectSelection}
                        input={
                        <OutlinedInput
                            labelWidth={100}
                            name="Project"
                            id="outlined-project-simple"
                        />
                        }
                    >
                        {this.state.project_names}
                    </Select>
                </FormControl>
                
                <div className="container">
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    {
                        this.state.selected_project &&
                        <Paper className={this.props.classes.root} style={{width: "100%", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Grid container spacing={16} justify="flex-start" alignItems="center">
                                <Grid item xs={3}>
                                    <Typography variant="h6" component="h2" align="justify">
                                        Project Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">{this.state.selected_project.name}</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h6" component="h2" align="justify">
                                        Total Quantity
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">{this.state.selected_project.qty}</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h6" component="h2" align="justify">
                                        Project Description
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">{this.state.selected_project.description}</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h6" component="h2" align="justify">
                                        Job Phases
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">{this.state.selected_project.job_actions.map((j, i) => i === this.state.selected_project.job_actions.length - 1 ?  j.job_action_name : j.job_action_name + ', ')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h6" component="h2" align="justify">
                                        Contractors who have worked on this:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1">{this.state.contractor_list.length > 0 ? this.state.contractor_list : '---'}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    }
                    { this.state.project_phase_rows.length > 0 &&
                        <Grid container spacing={0} justify="flex-start" alignItems="center" style={{marginTop: 15}}>
                            <Grid item xs={12} style={{padding: 8}}>
                                <Typography variant="h6" component="h2" align="justify">
                                    Project Phases
                                </Typography>
                            </Grid>
                            {this.state.project_phase_rows}
                        </Grid>
                    }
                    {
                        this.state.selected_project &&
                        <Grid container spacing={0} justify="flex-start" alignItems="center" style={{marginTop: 15}}>
                            <Grid item xs={12} style={{padding: 8}}>
                                <Typography variant="h6" component="h2" align="justify">
                                    Items used
                                </Typography>
                            </Grid>
                            {this.state.project_items_rows}
                        </Grid>
                    }
                </div>
            </div>
        );
    }

}

export default withStyles(styles)(ProjectReport);